
<div *ngIf="spendingPlan" class="w-full flex flex-col items-center">
  <div class="flex flex-col gap-4 items-center w-full">
    <div class="w-full flex flex-col gap-y-3 items-end pt-8">
      <div class="relative inline-block text-left">
        <div>
          <button (click)="showActionDropdown = !showActionDropdown; $event.stopPropagation()" type="button" class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" id="menu-button" aria-expanded="true" aria-haspopup="true">
            Actions
            <svg class="-mr-1 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
        <div *ngIf="showActionDropdown" (clickOutside)="showActionDropdown = false"  class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
          <div class="py-1" role="none">
            <a (click)="showActionDropdown = false; onComment()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-0">Comment</a>
            <a (click)="showActionDropdown = false; onEdit()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-1">Edit</a>
            <a (click)="showActionDropdown = false; onDelete()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-2">Delete</a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-5 md:gap-10 items-center w-full mb-20">
      <div class="w-full flex flex-row justify-center">
        <tandem-spending-plan-graph class="w-3/4 h-auto" [spendingPlan]="spendingPlan"></tandem-spending-plan-graph>
      </div>
      <div class="flex flex-col sm:flex-row w-full gap-8">
        <div class="w-1/2 flex flex-col items-center">
          <div class="max-sm:hidden flex flex-col gap-y-3">
            <h2 class="text-2xl font-bold">Revenue</h2>
            <h5 class="text-lg">Total Revenue: {{spendingPlan.totalRevenue | currency}}</h5>
          </div>
        </div>
        <div class="w-1/2 flex flex-col items-center">
          <div class="max-sm:hidden flex flex-col gap-y-3">
            <h2 class="text-2xl font-bold">Expenses</h2>
            <h5 *ngFor="let sec of expenseLabels" class="text-lg">{{sec.label}}: {{sec.amount | currency}}</h5>
            <h5 class="text-lg">Total Expenses: {{spendingPlan.totalExpenses | currency}}</h5>

          </div>

        </div>
      </div>
      <div class="flex flex-col w-full items-center gap-8">
        <div *ngFor="let section of spendingPlan.revenueSections; let i = index" class="w-full md:w-3/4 lg:w-1/2 flex flex-col items-center">
          <div class="flex flex-col">
            <h2 class="text-2xl font-bold">{{ section.name }}</h2>
            <h5 class="text-lg">{{getSummaryText('revenue', section, i)}}</h5>
          </div>
          <tandem-statement-item-table class="w-full max-w-4xl" *ngFor="let cat of section.categories" [statementItemSection]="section" [statementItemCategory]="cat" [displayMoveOption]="false" [mode]="'view'" [displayDate]="true" (onComment)="handleRevenueComment($event)" [categoryType]="'revenue'"></tandem-statement-item-table>
        </div>
      </div>
      <div class="flex flex-col w-full items-center gap-8">
        <div *ngFor="let section of spendingPlan.expenseSections; let i = index" class="w-full md:w-3/4 lg:w-1/2 flex flex-col items-center">
          <div class="flex flex-col">
            <h2 class="text-2xl font-bold">{{ section.name }}</h2>
            <h5 class="text-lg">{{getSummaryText('expense', section, i)}}</h5>
          </div>
          <tandem-statement-item-table class="w-full max-w-4xl" *ngFor="let cat of section.categories" [statementItemSection]="section" [statementItemCategory]="cat" [displayMoveOption]="false" [mode]="'view'" [displayDate]="true" (onComment)="handleExpenseComment($event)" [categoryType]="'expense'"></tandem-statement-item-table>
        </div>
      </div>
    </div>
  </div>
</div>
